import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M640,960.333333 L640,1173.66667 L1280,1173.66667 L1280,960.333333 L1920,960.333333 L1920,1547 C1920,1693.98667 1800.32,1813.66667 1653.33333,1813.66667 L1653.33333,1813.66667 L266.666667,1813.66667 C119.68,1813.66667 0,1693.98667 0,1547 L0,1547 L0,960.333333 L640,960.333333 Z M1120,107 C1208.21333,107 1280,178.786667 1280,267 L1280,267 L1280,427 L1653.33333,427 C1800.32,427 1920,546.68 1920,693.666667 L1920,693.666667 L1920,853.666667 L1280,853.666667 L1280,747 L640,747 L640,853.666667 L0,853.666667 L0,693.666667 C0,546.68 119.68,427 266.666667,427 L266.666667,427 L640,427 L640,267 C640,178.786667 711.786667,107 800,107 L800,107 Z M1120,213.666667 L800,213.666667 C770.56,213.666667 746.666667,237.56 746.666667,267 L746.666667,267 L746.666667,427 L1173.33333,427 L1173.33333,267 C1173.33333,237.56 1149.44,213.666667 1120,213.666667 L1120,213.666667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEportfolioSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEportfolioSolid, _Component);

  var _super = _createSuper(IconEportfolioSolid);

  function IconEportfolioSolid() {
    _classCallCheck(this, IconEportfolioSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEportfolioSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEportfolio",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconEportfolioSolid.displayName = "IconEportfolioSolid";
  return IconEportfolioSolid;
}(Component);

IconEportfolioSolid.glyphName = 'eportfolio';
IconEportfolioSolid.variant = 'Solid';
IconEportfolioSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEportfolioSolid;
export { IconEportfolioSolid };